var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderRemoveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.66666H10M2 11.3333V4.66666C2 4.31304 2.14048 3.9739 2.39052 3.72385C2.64057 3.4738 2.97971 3.33333 3.33333 3.33333H7.33333L8.66667 4.66666H12.6667C13.0203 4.66666 13.3594 4.80714 13.6095 5.05719C13.8595 5.30723 14 5.64637 14 5.99999V11.3333C14 11.6869 13.8595 12.0261 13.6095 12.2761C13.3594 12.5262 13.0203 12.6667 12.6667 12.6667H3.33333C2.97971 12.6667 2.64057 12.5262 2.39052 12.2761C2.14048 12.0261 2 11.6869 2 11.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderRemoveOutline);
export default __webpack_public_path__ + "static/media/FolderRemoveOutline.4598ab550c64afca11aba9b1a7fa9e97.svg";
export { ForwardRef as ReactComponent };